const linkTypes = (log, type) => ({
  id: log._id,
  date: log.date,
  type,
  type_id: log[`${type}_id`],
  description: log[`${type}_name`],
});

const boldTemplate = (innerHTML, classes) => ({
  tag: 'b',
  class: classes,
  domProps: {
    innerHTML,
  },
});

const logLinkTemplate = (innerHTML, params, classList = []) => {
  return {
    tag: 'a',
    domProps: {
      innerHTML,
    },
    on: {
      click: e => {
        e.preventDefault();
        window.$eventHub.$emit('showPopUpLog', params);
      },
    },
    class: classList,
  };
};

export const user_update_profile = log => [
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  ' updated personal profile.',
];

export const media_updated = log => [
  logLinkTemplate(log.creator_name, linkTypes(log, 'creator')),
  ' updated media ',
  logLinkTemplate(log.media_name, linkTypes(log, 'media')),
  ' for ',
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  '.',
];

export const media_uploaded = log => [
  logLinkTemplate(log.creator_name, linkTypes(log, 'creator')),
  ' uploaded media ',
  logLinkTemplate(log.media_name, linkTypes(log, 'media')),
  ' for ',
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  '.',
];

export const media_deleted = log => [
  logLinkTemplate(log.creator_name, linkTypes(log, 'creator')),
  ' deleted media ',
  logLinkTemplate(log.media_name, linkTypes(log, 'media')),
  ' for ',
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  '.',
];

export const user_created = log => [
  logLinkTemplate(log.creator_name, linkTypes(log, 'creator')),
  ' created customer ',
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  '.',
];

export const user_updated = log => [
  logLinkTemplate(log.creator_name, linkTypes(log, 'creator')),
  ' updated ',
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  ' profile.',
];

export const user_deactivated = log => [
  logLinkTemplate(log.creator_name, linkTypes(log, 'creator')),
  ' deleted ',
  logLinkTemplate(log.user_name, linkTypes(log, 'user')),
  ' profile.',
];

export const defaultTemplate = ({ type }) => [
  'Unsupported template [',
  type,
  ']',
];
